import {
  LayoutDashboard,
  Users,
  UserCog,
  FileText,
  DollarSign,
  MessageSquare,
  CalendarDays,
  Settings,
  HelpCircle,
  type LucideIcon,
} from 'lucide-react'
import type { UserRole } from '@/types'

export interface NavItem {
  labelKey:
    | 'pages.dashboard'
    | 'pages.patients'
    | 'pages.staff'
    | 'pages.documents'
    | 'pages.financials'
    | 'pages.chat'
    | 'pages.schedule'
    | 'pages.settings'
    | 'pages.help'
  path: string
  icon: LucideIcon
  roles?: UserRole[]
}

export const mainNavItems: NavItem[] = [
  { labelKey: 'pages.dashboard', path: '/dashboard', icon: LayoutDashboard },
  { labelKey: 'pages.patients', path: '/patients', icon: Users },
  {
    labelKey: 'pages.staff',
    path: '/staff',
    icon: UserCog,
    roles: ['OWNER', 'ADMIN', 'MANAGER'] as UserRole[],
  },
  {
    labelKey: 'pages.documents',
    path: '/documents',
    icon: FileText,
    roles: ['OWNER', 'ADMIN', 'MANAGER'],
  },
  {
    labelKey: 'pages.financials',
    path: '/financials',
    icon: DollarSign,
    roles: ['OWNER', 'ADMIN'],
  },
  {
    labelKey: 'pages.chat',
    path: '/chat',
    icon: MessageSquare,
    roles: ['OWNER', 'ADMIN', 'MANAGER'] as UserRole[],
  },
  { labelKey: 'pages.schedule', path: '/schedule', icon: CalendarDays },
]

export const secondaryNavItems: NavItem[] = [
  { labelKey: 'pages.settings', path: '/settings', icon: Settings },
  { labelKey: 'pages.help', path: '/help', icon: HelpCircle },
]
